module.exports = __webpack_public_path__ + "img/yw_4.e406343f.png";